import React, { useReducer } from 'react'
import { reducer } from './reducers'
import { AppContext, defaultState } from './store'

export const AdministrationsStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [globalState, dispatch] = useReducer(reducer, defaultState)

  return <AppContext.Provider
    value={{ globalState, dispatch }}
    children={children}
  />
}
